import { isNullish } from './helper'

export const camelToWords = (str) => {
  let newKey = ''
  let index = 0
  let code
  let wasPrevNumber = true
  let wasPrevUppercase = true

  if (typeof str != 'string') {
    return ''
  }

  while (index < str.length) {
    code = str.charCodeAt(index)
    if (index === 0) {
      newKey += str[index].toUpperCase()
    } else if ((!wasPrevUppercase && code >= 65 && code <= 90) || (!wasPrevNumber && code >= 48 && code <= 57)) {
      newKey += ' '
      newKey += str[index].toUpperCase()
    } else {
      newKey += str[index].toLowerCase()
    }
    wasPrevNumber = code >= 48 && code <= 57
    wasPrevUppercase = code >= 65 && code <= 90
    index++
  }

  return newKey
}

export const numberWithCommas = (number) => {
  if (!number) {
    return 0
  }

  const formattedNumber = Math.round((parseFloat(number) + Number.EPSILON) * 100) / 100

  return formattedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const roundNumber = (number, digit = 2) =>
  Math.round((parseFloat(number) + Number.EPSILON) * 10 ** digit) / 10 ** digit

export const round = (value, decimals) => Number(`${Math.round(`${value}e${decimals}`)}e-${decimals}`)

export const capitalizeFirstLetter = (string) => {
  if (typeof string !== 'string') {
    return string
  }

  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const isDate = (date) => Object.prototype.toString.call(date) === '[object Date]'

export const isEmpty = (obj) => [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length

export const isNumeric = (str) => {
  if (typeof str === 'number') {
    return true
  }

  if (typeof str !== 'string') return false // we only process strings!

  console.log('is string')
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ) // ...and ensure strings of whitespace fail
}

export const isString = (str) => typeof str === 'string' || str instanceof String

export const stringToNumber = (str) => {
  if (typeof str === 'number') {
    return str
  }

  if (typeof str !== 'string') {
    return 0
  }

  return Number(str.replace(/[,/#!$%^&*;:{}=\-_`~()]/g, ''))
}

export const getNumberOrdinal = (number) => {
  if (typeof number !== 'number') {
    return ''
  }

  let ord = 'th'

  if (number % 10 == 1 && number % 100 != 11) {
    ord = 'st'
  } else if (number % 10 == 2 && number % 100 != 12) {
    ord = 'nd'
  } else if (number % 10 == 3 && number % 100 != 13) {
    ord = 'rd'
  }

  return number + ord
}

export const isValidNonEmptyString = (str) => {
  if (isNullish(str) || typeof str !== 'string') {
    return false
  }

  return str !== ''
}

export const numberToColumnKey = (index) => {
  let columnKey = ''
  while (index > 0) {
    let remainder = (index - 1) % 26
    columnKey = String.fromCharCode(65 + remainder) + columnKey
    index = Math.floor((index - 1) / 26)
  }
  return columnKey
}
